module.exports = __webpack_public_path__ + "img/d320-icon.21d45a3b.jpg";